import { HotkeyOption } from './hotkey-option';

// A floorball turnover: the other team gains clear control after this team had
// clear control, either right away or after nobody had clear control for a
// moment (neutral). Shots and game interruptions are not turnovers. Only
// visible facts, so two collectors code the same play the same way.
export type TurnoverType = 'pass' | 'one_on_one' | 'other';

export type TurnoverScenario = 'direct' | 'via_neutral';

// The hotkey is the letter the collector presses once the turnover (l) is chosen.
export type TurnoverOption<T> = HotkeyOption<T>;

// The first type that fits wins: a pass before an opponent's action.
// pass: the last action was a pass that no teammate received; one_on_one: an
// opponent took the ball away or broke possession.
export const turnoverTypes: TurnoverOption<TurnoverType>[] = [
  { value: 'pass', label: 'Pass', hotkey: 'p' },
  { value: 'one_on_one', label: '1-on-1', hotkey: 'b' },
  { value: 'other', label: 'Other', hotkey: 'o' }
];

export const turnoverScenarios: TurnoverOption<TurnoverScenario>[] = [
  { value: 'direct', label: 'Direct', hotkey: 'd' },
  { value: 'via_neutral', label: 'Via neutral', hotkey: 'n' }
];
